export const SCALE_HOURLY = 'hourly';
export const SCALE_DAILY = 'daily';
export const SCALE_WEEKLY = 'weekly';
export const SCALE_MONTHLY = 'monthly';
export const SCALE_MONTH_TO_DATE = 'monthToDate';

export const SCALE_QUARTERLY = 'quarterly';

export const HIDDEN_Y_AXIS_ID = 'HIDDEN_Y_AXIS_ID';

export const VALUE_TYPE_NUMBER = 'number';
export const VALUE_TYPE_CURRENCY = 'currency';
export const VALUE_TYPE_PERCENT = 'percent';

export const START_DAY_MON = 'monday';
export const START_DAY_TUE = 'tuesday';
export const START_DAY_WED = 'wednesday';
export const START_DAY_THU = 'thursday';
export const START_DAY_FRI = 'friday';
export const START_DAY_SAT = 'saturday';
export const START_DAY_SUN = 'sunday';
